import { isChargerInstallationRebate } from 'site-modules/shared/components/incentives/incentives-wizard/utils/is-charger-installation-rebate';
import {
  CUSTOMER_OF_QUESTION_ID,
  INSTALL_EV_CHARGER_QUESTION_ID,
} from 'site-modules/shared/components/incentives/incentives-wizard/questions/questions';
import { isUtilityEvChargingOfferRebate } from './is-utility-ev-charging-offer-rebate';

export function filterOutIncentivesWithClientSideEligibilityCheck(incentives, answers) {
  const chargerInstallationIncentives = incentives.filter(incentive => isChargerInstallationRebate(incentive));

  if (!chargerInstallationIncentives.length) {
    return incentives;
  }

  const chargerInstallationAnswer = answers[INSTALL_EV_CHARGER_QUESTION_ID][0];

  if (!chargerInstallationAnswer) {
    return incentives.filter(incentive => !isChargerInstallationRebate(incentive));
  }

  const customerOfAnswer = answers[CUSTOMER_OF_QUESTION_ID]?.[0];

  return incentives.filter(
    incentive => !isUtilityEvChargingOfferRebate(incentive) || incentive.id === customerOfAnswer
  );
}
